<template>
    <div class="login">
        <div class="horizontal-layout horizontal-menu 1-column   menu-expanded blank-page blank-page  pace-done">
            <div class="app-content content" id="app">
                <div class="content-wrapper">
                    <div class="content-body">
                        <section class="flexbox-container">
                            <div class="col-12 d-flex align-items-center justify-content-center">
                                <div class="col-md-4 col-10 box-shadow-2 p-0">
                                    <div class="card border-grey border-lighten-3 m-0 p-3">
                                        <div class="card-header border-0">
                                            <div class="card-title text-center">
                                                <div class="p-1">
                                                    <h1>
                                                    <strong>{{$t('hello')}}</strong>
                                                    </h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="mb-2" v-if="errors.first('email') || errors.first('password') || loginData.error.error == 'bad_authentication'">
                                                    <small class="text-danger d-block" v-if="loginData.error.error == 'bad_authentication'">{{ $t('errors.wrong_credentials') }}</small>
                                                    <small class="text-danger d-block" v-if="errors.first('email')">{{ $t('errors.email') }}</small>
                                                    <small class="text-danger d-block" v-if="errors.first('password')">{{ $t('errors.password') }}</small>
                                                </div>
                                                <form class="form-horizontal form-simple" @submit.prevent="doLogin">
                                                    <fieldset class="form-group position-relative has-icon-left mb-0">
                                                        <input name="email" v-validate="'required|email'" :value="loginData.request.login" @input="updateUser" type="text" class="form-control form-control-lg input-lg" id="user-name" v-bind:placeholder="$t('email')" required="" aria-invalid="false">
                                                        <div class="form-control-position">
                                                            <i class="ft-user"></i>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset class="form-group position-relative has-icon-left">
                                                        <input type="password" name="password" v-validate="'required|min:6'" :value="loginData.request.password" @input="updatePassword" class="form-control form-control-lg input-lg" id="user-password" v-bind:placeholder="$t('password')" required="" autocomplete="">
                                                        <div class="form-control-position">
                                                            <i class="la la-key"></i>
                                                        </div>
                                                    </fieldset>
                                                    <button class="btn btn-info  round btn-lg btn-block">
                                                        <i class="ft-unlock"></i> {{$t('login_label')}}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <p class="float-sm-left text-center m-0">
                                                <router-link to="/reset-password" class="card-link">{{$t('password_recovery')}}</router-link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  computed: {
    loginData () {
      return this.$store.getters.getLoginData
    }
  },
  methods: {
    updateUser (e) {
      this.$store.commit('updateUser', e.target.value)
    },
    updatePassword (e) {
      this.$store.commit('updatePassword', e.target.value)
    },
    doLogin () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$socket.send(this.$store.state.loginData.request)
        }
      })
    }
  }
}

</script>
<style lang="scss">
    @import '../app-assets/css/pages/login-register.css';
</style>
